import request from '@/utils/request'

// 用户列表
export function fetchList(data) {
	return request({
		url: '/oms/user/list',
		method: 'POST',
		data
	})
}

// 用户详情
export function getConsumerDetail(params) {
	return request({
		url: '/oms/user/detail',
		method: 'GET',
		params
	})
}

// 用户Note列表
export function fetchUserNoteList(data) {
	return request({
		url: '/oms/user/note/list',
		method: 'POST',
		data
	})
}

//新增用户
export function addUser(data) {
	return request({
		url: '/oms/user/add',
		method: 'POST',
		data
	})
}

//用户查询
export function searchUser(query){
	return request({
		url: '/oms/user/search',
		method: 'GET',
		params: {query}
	})
}



// WEBPACK FOOTER //
// ./src/api/cs/consumer.js